"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var currency_js_1 = __importDefault(require("currency.js"));
var React = __importStar(require("react"));
var store_credit_1 = require("../../../misc/store-credit");
var tooltip_1 = __importDefault(require("../../../plugins/tooltip"));
var format_bundle_variant_title_1 = __importDefault(require("../../../utils/format-bundle-variant-title"));
var format_price_1 = __importDefault(require("../../../utils/format-price"));
var app_1 = require("../app");
var step_header_1 = __importDefault(require("../components/step-header"));
var useContext = React.useContext, useEffect = React.useEffect;
var renderStars = function (numTimes) { return (React.createElement(React.Fragment, null, __spreadArray([], __read(Array(Math.floor(numTimes)).keys()), false).map(function (i) { return (React.createElement("i", { className: 'spr-icon spr-icon-star text-pale-gold', key: "star".concat(i) })); }))); };
exports.default = (function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var _k = useContext(app_1.AppContext), choices = _k.choices, totalBundlePrice = _k.totalBundlePrice, setLeftSideImage = _k.setLeftSideImage, size = _k.size, existingCustomerNewBundleDiscount = _k.existingCustomerNewBundleDiscount, existingCustomerNewBundleSavings = _k.existingCustomerNewBundleSavings;
    var productsData = (_a = window.vitaminBundlerApp) === null || _a === void 0 ? void 0 : _a.productsData;
    var showReviews = (_b = window.vitaminBundlerApp) === null || _b === void 0 ? void 0 : _b.settings.review.showReviews;
    var reviews = ((_c = window.vitaminBundlerApp) === null || _c === void 0 ? void 0 : _c.settings.review.reviews) || [];
    var numReviews = reviews.length;
    var avgRating = reviews.reduce(function (sum, review) { return sum + review.rating; }, 0) / numReviews;
    var originalBundleCost = choices.reduce(function (sum, choice) { return sum + choice.variant.compare_at_price * choice.quantity; }, 0);
    var totalBundleSavings = originalBundleCost - (totalBundlePrice || 0);
    setLeftSideImage((_d = window.vitaminBundlerApp) === null || _d === void 0 ? void 0 : _d.settings.review.leftImage);
    useEffect(function () {
        var _a;
        var data = choices.map(function (c) { return ({ name: c.variant.name, quantity: c.quantity }); });
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'vitaminBundle__review', selectedSize: size, vitaminBundleItems: data });
    }, []);
    var isLoggedIn = !!((_e = window.customer) === null || _e === void 0 ? void 0 : _e.id);
    var customerCreditAccountQuery = (0, store_credit_1.useCustomerCreditAccount)({ enabled: !!isLoggedIn });
    var customerStoreCreditBalance = ((_g = (_f = customerCreditAccountQuery.data) === null || _f === void 0 ? void 0 : _f.account.creditAccount) === null || _g === void 0 ? void 0 : _g.available_balance)
        ? Number(customerCreditAccountQuery.data.account.creditAccount.available_balance)
        : 0;
    return (React.createElement("div", { className: 'grid-y height-100' },
        React.createElement("div", { className: 'grid-container' },
            React.createElement(step_header_1.default, { title: (_h = window.vitaminBundlerApp) === null || _h === void 0 ? void 0 : _h.settings.review.title, subtitle: (_j = window.vitaminBundlerApp) === null || _j === void 0 ? void 0 : _j.settings.review.subtitle }),
            React.createElement("div", { className: 'grid-x align-middle' },
                React.createElement("div", { className: 'cell small-3 medium-2' }, "\u00A0"),
                React.createElement("div", { className: 'cell auto' },
                    React.createElement("div", { className: 'text-sandy-brown' }, "Total bundle savings"),
                    React.createElement("div", { className: 'text-nobel font-italic font-lighter' }, "Original bundle value"),
                    existingCustomerNewBundleDiscount && React.createElement("div", { className: 'text-sandy-brown' }, "Discount savings")),
                React.createElement("div", { className: 'cell small-3 font-lighter' },
                    React.createElement("div", { className: 'text-sandy-brown font-bold' }, (0, format_price_1.default)(totalBundleSavings)),
                    React.createElement("div", { className: 'text-nobel' }, (0, format_price_1.default)(originalBundleCost)),
                    existingCustomerNewBundleSavings && React.createElement("div", { className: 'text-sandy-brown font-bold' },
                        "-",
                        (0, format_price_1.default)(existingCustomerNewBundleSavings)))),
            customerStoreCreditBalance > 0 ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: 'margin-top-3' }),
                React.createElement("div", { className: 'padding-horizontal-4 text-center h6-7 text-gray font-lighter' },
                    "Your Store Credit will automatically apply.",
                    React.createElement(tooltip_1.default, { button: React.createElement("i", { className: 'ss-info padding-left-1 h6-7 text-gray font-lighter', style: { verticalAlign: 'middle', lineHeight: '100%' } }) },
                        React.createElement("div", { className: 'padding-3 h6-7 text-gray' },
                            "You have ",
                            React.createElement("span", { className: 'font-bold' },
                                "$",
                                (0, currency_js_1.default)(customerStoreCreditBalance).toString()),
                            " in Store Credit available."))),
                React.createElement("div", { className: 'margin-top-3' }))) : (React.createElement("div", { className: 'margin-top-5' })),
            React.createElement("hr", { className: 'margin-top-0' }),
            React.createElement("div", null, choices.map(function (_a) {
                var product = _a.product, variant = _a.variant, quantity = _a.quantity;
                var productData = productsData && productsData[product.handle];
                var variantData = productData === null || productData === void 0 ? void 0 : productData.variants[variant.id];
                return (React.createElement("div", { className: 'grid-x align-middle margin-bottom-2', key: "choice".concat(variant.id) },
                    React.createElement("div", { className: 'cell small-3 medium-2 text-center' },
                        React.createElement("img", { src: variant.featured_image ? variant.featured_image.src : product.featured_image, alt: variant.title })),
                    React.createElement("div", { className: 'cell auto text-gray' },
                        React.createElement("div", { className: 'font-bold' }, (0, format_bundle_variant_title_1.default)(product.title)),
                        React.createElement("div", { className: 'font-lighter' },
                            "(",
                            quantity,
                            ") ", variantData === null || variantData === void 0 ? void 0 :
                            variantData.daysPer,
                            " servings each")),
                    React.createElement("div", { className: 'cell small-3 font-lighter' }, variant.compare_at_price && React.createElement("div", { className: 'text-nobel strike' }, (0, format_price_1.default)(variant.compare_at_price * quantity)))));
            }))),
        showReviews && (React.createElement("div", { className: 'flex-child-auto bg-pampas text-center' },
            React.createElement("div", { className: 'grid-container padding-vertical-8 large-padding-vertical-10' },
                React.createElement("h3", null, "Customer Reviews"),
                React.createElement("div", { className: 'text-gray font-lighter margin-bottom-6' },
                    React.createElement("span", { className: 'margin-right-3' }, renderStars(avgRating)),
                    "Based on ",
                    numReviews,
                    " reviews"),
                React.createElement("div", { className: 'vitamin-bundler-reviews-grid' }, reviews.map(function (review) { return (React.createElement("div", { className: 'bg-white padding-6', key: review.id },
                    React.createElement("div", null, renderStars(review.rating)),
                    React.createElement("div", { className: 'margin-vertical-4' }, review.review),
                    React.createElement("div", { className: 'h7 font-bold text-uppercase' }, review.byline))); })))))));
});
